import { Interaction } from '@youversion/analytics-youversion-nextjs';
import { cn, Heading, LinkButton } from '@youversion/design-system-components';

import { useUXHooks } from '@/hooks';
import { analyticsElementIds } from '@/utils/analytics/elements';

import YvLogo from '../../../public/images/yv-wordmark-2021.svg';

export const Sidebar = () => {
  const { sidebar } = useUXHooks();

  return (
    <aside className={cn('hidden lg:flex flex-col w-full max-w-[460px] overflow-hidden', sidebar.backgroundColor)}>
      <div className='mbs-4'>
        <div className='pli-3'>
          <YvLogo className='mbe-8 shrink-0 text-warm-neutral' />
        </div>
        <div className='pli-10'>
          <Heading
            className='mbe-3 text-text-dark'
            font={sidebar.tagline.font ?? 'primary'}
            level={1}
            size='md'
            variant='headline'
          >
            {sidebar.tagline.text}
          </Heading>

          {sidebar.button ? (
            <LinkButton
              href={sidebar.button.url}
              onClick={() =>
                Interaction.App.fire(
                  {
                    elementId: analyticsElementIds.getAppBtn,
                    elementState: 'selecting',
                    success: true,
                  },
                  { fireImmediately: true }
                )
              }
              target='_blank'
              variant='filled:contrast'
            >
              {sidebar.button.text}
            </LinkButton>
          ) : null}
        </div>
      </div>
      <div className='flex flex-grow items-end relative'>
        <div className='absolute'>{sidebar.wave}</div>
        {sidebar.phone}
      </div>
    </aside>
  );
};
